import axios from 'axios'
// import apiClient from './apiClient'
import Cookies from 'js-cookie'
import {
  getValidInstituteIdFromCookie,
  resolveInstituteIdHeaders,
} from '../../utils/instituteIdCookie'
import {
  clearAssignedInstitutesCache,
  withAssignedInstitutesCache,
} from '../../utils/assignedInstitutesCache'

export { clearAssignedInstitutesCache }


// export const BASE_URL = 'https://ttaapi.vibhumsoftware.com/api'
// export const BASE_URL_Upload = 'https://ttaapi.vibhumsoftware.com'

export const BASE_URL = 'https://schoolapi.virtualprachar.com/api'
export const BASE_URL_Upload = 'https://schoolapi.virtualprachar.com'


// export const BASE_URL = 'http://127.0.0.1:8000/api'
// export const BASE_URL_Upload = 'http://127.0.0.1:8000'

/** Institute logo upload (multipart). Uses Virtual Prachar API; field name must be `image`. */
// export const INSTITUTE_LOGO_API_BASE = 'https://schoolapi.virtualprachar.com/api'
export const CLOUD_BASE_URL = 'https://pub-f40a0417525949609595f4b02df910a3.r2.dev'

/**
 * Many transport routes expect `Institute-Id` like `/transport/all`.
 * Prefer `institute_id` cookie; else use `institute_id` on the `user` cookie (e.g. bus attendant).
 */
export function resolveTransportInstituteHeaders() {
  const id = getValidInstituteIdFromCookie()
  if (id == null) return {}
  return { 'Institute-Id': id }
}

function sanitizeInstituteHeaders(config) {
  const keys = ['institute-Id', 'Institute-Id']
  for (const key of keys) {
    const raw = config.headers?.[key]
    if (raw === undefined || raw === null || raw === '') continue
    const n = Number(raw)
    if (!Number.isFinite(n) || n <= 0) {
      delete config.headers[key]
    }
  }
}


const apiClient = axios.create({
  baseURL: BASE_URL,
  // headers: {
  //   'Content-Type': 'application/json',
  //   Accept: 'application/json',
  // },
})

apiClient.interceptors.request.use(
  (config) => {
    try {
      const userCookie = Cookies.get('user')
      if (userCookie) {
        const user = JSON.parse(userCookie)

        if (user.token && !config.headers['Authorization'] && !config.headers['authorization']) {
          config.headers['Authorization'] = `Bearer ${user.token}`
        }

        if (user.name) {
          config.headers['name'] = user.name
        }
      }

      sanitizeInstituteHeaders(config)

      const resolved = resolveInstituteIdHeaders()
      if (resolved['institute-Id']) {
        const hasValidHeader = ['institute-Id', 'Institute-Id'].some((key) => {
          const n = Number(config.headers?.[key])
          return Number.isFinite(n) && n > 0
        })
        if (!hasValidHeader) {
          config.headers['institute-Id'] = resolved['institute-Id']
        }
      }

      return config
    } catch (err) {
      console.error('❌ Error parsing user cookie:', err)
      return config // allow request even if cookie parsing fails
    }
  },
  (error) => {
    console.error('❌ Request Interceptor Error:', error)
    return Promise.reject(error)
  },
)

/** GET /users/institute — shared in-flight dedup + short TTL cache. */
export function fetchAssignedInstitutes(options = {}) {
  return withAssignedInstitutesCache(() => apiClient.get('/users/institute'), options)
}

const ApiEndpoints = {
  signUp: (signupData) => apiClient.post('/signup', signupData),
  register: (registerData) =>
    apiClient.post('/register', registerData, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  login: (loginUser) => apiClient.post('/login', loginUser),
  googleLogin: (idToken) =>
    apiClient.post(
      '/login/google',
      {},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    ),

  // Dashboard
  getDashboardData: () => apiClient.get('/dashboard'),
  getFeesByMonths: () => apiClient.get('/dashboard/fees-by-months'),
  getStudentCount: () => apiClient.get('dashboard/students-count'),
  getCourseCount: () => apiClient.get('students/count-by-course'),

  getAllStudents: () => apiClient.get('/student/all'),
  addStudent: (studentData) => apiClient.post('/student/add', studentData),
  // addStudentImage: (studentImage) =>
  //   apiClient.post('/upload-image', studentImage),

  editStudent: (id, studentData) =>
    apiClient.put(`/student/${id}`, studentData),
  viewProfile: (id) => apiClient.get(`/student/${id}`),
// viewProfile: (id, headers = {}) => {
//   const instituteId = Cookies.get('institute_id')
//   return apiClient.get(`/student/${id}`, {
//     headers: {
//       'institute-Id': Number(instituteId),
//     },
//   })
// },

  // getAllCourses: () => apiClient.get('/course/all'),
  getAllCourses: () =>
    apiClient.get('/course/all', { headers: resolveInstituteIdHeaders() }),
  // addCourse: (courseData, instituteId) =>
  //   apiClient.post('/course/add', courseData, {
  //     headers: {
  //       'institute-Id': Number(instituteId),
  //     },
  //   }),
  // getAllCourses: () => {
  //   const instituteId = Cookies.get('institute_id')

  //   if (!instituteId) {
  //     console.warn('Institute ID is missing. No API call will be made.')
  //     return Promise.resolve({ data: { data: [] } }) // Return empty course list safely
  //   }

  //   return apiClient.get('/course/all', {
  //     headers: {
  //       'institute-Id': Number(instituteId),
  //     },
  //   })
  // },

  addCourse: (courseData, instituteId) => {
    // console.log('Adding course for institute:', instituteId)
    return apiClient.post('/course/add', {
      ...courseData,
      // institute_id: Number(instituteId),
    },{
      headers: {
        'institute-Id': Number(instituteId),
      },
    })
  },

  editCourse: (id, courseData) =>
    apiClient.put(`/course/edit/${id}`, courseData),

  // getAllClasses: () => apiClient.get('/class/all'),
  getAllClasses: () => {
    const institueId = Cookies.get('institute_id')
    console.log('🏫 Institute ID for class:', institueId)
    return apiClient.get('/class/all', {
      headers: {
        'institute-Id': Number(institueId),
      },
    })
  },
  
//   getAllClasses: (instituteIdParam) => {
//   // 1. Try direct cookie (works for admin)
//   let instituteId = Cookies.get('institute_id') || instituteIdParam

//   // 2. If not found, try parsing from "user" cookie (for teacher)
//   if (!instituteId) {
//     const userCookie = Cookies.get('user')
//     if (userCookie) {
//       try {
//         const user = JSON.parse(userCookie)
//         instituteId = user.institute_id
//       } catch (err) {
//         console.error("❌ Failed to parse user cookie:", err)
//       }
//     }
//   }

//   console.log('🏫 Institute ID for class:', instituteId)

//   // 3. If still missing, warn and return fallback request
//   if (!instituteId) {
//     console.warn("⚠️ No institute_id found. Sending request without it.")
//     return apiClient.get('/class/all')
//   }

//   // 4. Send with proper header
//   return apiClient.get('/class/all', {
//     headers: {
//       'institute-Id': Number(instituteId),
//     },
//   })
// },

  addClass: (classData, institueId) => apiClient.post('/class/add', classData, {
    headers: {
      'institute-Id': Number(institueId),
    },
  }),
  editClass: (id, studentData) =>
    apiClient.put(`/class/edit/${id}`, studentData),
  getAllClassesByCourseId: (classCourseId) =>
    apiClient.get(`/get/classes/by/${classCourseId}`),

  // getAllInstitutes: () => apiClient.get('/institute/all'),
  getAllInstitutesAssinged: () => fetchAssignedInstitutes(),
  getAllInstitutes: () => fetchAssignedInstitutes(),
  addInstitute: (instituteData) =>
    apiClient.post('/institute/add', instituteData),
  // Virtual Prachar API: POST multipart with field `image` + Bearer (same token as app cookie).
  uploadInstituteLogo: (instituteId, formData) => {
    const userCookie = Cookies.get('user')
    let token = ''
  
    if (userCookie) {
      const user = JSON.parse(userCookie)
      token = user.token
    }
  
    return axios.post(
      `${BASE_URL}/institute/${instituteId}/logo`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  },
  editInstitute: (id, instituteData) =>
    apiClient.put(`/institute/${id}`, instituteData),
  // getAllInstituteById: (institueId) =>
  //   apiClient.get(`/institute/${institueId}`),

  getAllSubjects: () => apiClient.get('/subject/all', {
    headers: {
      'institute-Id': Number(Cookies.get('institute_id')),
    },
  }),
  getSubjectsByCourse: (course_id, data) =>
    apiClient.get(`/get/subjects/by-course?course_id=${course_id}`, data),

  addSubject: (subjectData) => apiClient.post('/subject/add', subjectData, {
    headers: {
      'institute-Id': Number(Cookies.get('institute_id')),
    },
  }),
  editSubject: (id, subjectData) =>
    apiClient.put(`/subject/edit/${id}`, subjectData),
  deleteSubject: (id) =>
    apiClient.delete(`/subject/delete/${id}`, {
      headers: {
        Accept: 'application/json',
      },
    }),

  getAllTeachers: (headers = {}) => apiClient.get('/teacher/all', { headers }),
  addTeacher: (teachersData) => apiClient.post('/teacher/add', teachersData),
  editTeacher: (id, teachersData) =>
    apiClient.put(`/teacher/${id}`, teachersData),
  addAssignClass: (assignClass) => apiClient.post('/assign-class', assignClass),
  getAllAssignedClasses: (assignedClasses) =>
    apiClient.get(`/teacher-classes/${assignedClasses}`),
  editAssignClassTeacher: (id, assignData, config) =>
    apiClient.put(`/update-assignment/${id}`, assignData, config),

  addParent: (parentData) => apiClient.post('/add/guardian', parentData),
  editParent: (id, parentData) =>
    apiClient.put(`/guardian/edit/${id}`, parentData),

  // getAllEnquiries: () => apiClient.get('/enquiries/all'),
  // addEnquiry: (enquiriesData) => apiClient.post('/enquiry/add', enquiriesData),
  getAllEnquiries: () => {
    const institueId = Cookies.get('institute_id')
    console.log('INStitute ID:', institueId)
    return apiClient.get('/enquiries/all', {
      headers: {
        'institute-Id': Number(institueId),
      },
    })
  },
  // addEnquiry: (enquiryData, token) => {
  //   console.log('Adding enquiry for institute:', instituteId)
  //   return apiClient.post('/enquiry/add', {
  //     ...enquiryData,
  //     'institute-Id': Number(instituteId),
  //   })
  // },
  // editEnquiry: (id, enquiriesData, headers) =>
  //   apiClient.put(`/enquiry/${id}`, enquiriesData, { headers }),
  addEnquiry: (enquiryData, token) => {
    return apiClient.post('/enquiry/add', enquiryData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  },

  addMarketer: (marketer) => apiClient.post('/add/marketer', marketer),

  getAllFees: () => apiClient.get('/fee/structure/get/all', {
    headers: {
      'institute-Id': Number(Cookies.get('institute_id')),
    },
  }),
  addFee: (feeData) => apiClient.post('/fee/structure/add', feeData),
  addStudentApplyFees: (studentApplyFessData) =>
    apiClient.post('/student/apply/fees', studentApplyFessData),
  submitStudentFee: (submitStudentFee) =>
    apiClient.post('/submit-student-fee', submitStudentFee),
  submitStudentFees: (payload) =>
    apiClient.post('/submit-student-fees', payload, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }),
  sendFeeReceiptWhatsapp: (payload) =>
    apiClient.post('/fees/send-receipt-whatsapp', payload),
  getAllFeesByStudentId: (student_id, course_id) =>
    apiClient.get(
      `/fees/student?student_id=${student_id}&course_id=${course_id}`,
    ),
  getAllFeesByStudentProfileId: (student_id) =>
    apiClient.get(`/get/all/fee/by/${student_id}`),

  getFeeChangeLogs: (params = {}) => {
    const cleanedParams = Object.fromEntries(
      Object.entries(params || {}).filter(
        ([, value]) => value !== undefined && value !== null && value !== '',
      ),
    )
    const instituteId = Number(Cookies.get('institute_id'))
    const headers = {
      Accept: 'application/json',
      ...resolveInstituteIdHeaders(),
    }
    if (Number.isFinite(instituteId) && instituteId > 0) {
      headers['Institute-Id'] = instituteId
    }
    return apiClient.get('/fees/change-logs', {
      params: cleanedParams,
      headers,
    })
  },

  getAllFeeCollection: () => apiClient.get('/fee-collection'),

  getAllExam: () => apiClient.get('/get/exam/all'),
  // addExam: (examData) => apiClient.post('/exam/add', examData),
  addExamMultiple: (examData) => apiClient.post('/exam/add-multiple', examData),
  editExam: (id, examData) => apiClient.put(`/update/exam/${id}`, examData),
  cancelExamById: (id) => apiClient.post(`/exam/cancel/${id}`),
  completeExamById: (id) => apiClient.post(`/exam/complete/${id}`),

  getExamSubjectSchedules: (examId) => {
    const instituteId = Cookies.get('institute_id')
    return apiClient.get('/exam/subject-schedules', {
      params: { exam_id: examId },
      headers: instituteId ? { 'institute-Id': Number(instituteId) } : {},
    })
  },
  createExamSubjectSchedulesBatch: (payload) => {
    const instituteId = Cookies.get('institute_id')
    return apiClient.post('/exam/subject-schedules', payload, {
      headers: instituteId ? { 'institute-Id': Number(instituteId) } : {},
    })
  },
  updateExamSubjectSchedule: (id, payload) => {
    const instituteId = Cookies.get('institute_id')
    return apiClient.put(`/exam/subject-schedules/${id}`, payload, {
      headers: instituteId ? { 'institute-Id': Number(instituteId) } : {},
    })
  },

  addStudentExamResult: (studentExamData) =>
    apiClient.post('/add/student/result', studentExamData),
  getStudentExamMarks: (student_id, course_id) =>
    apiClient.get(`/student/results/${student_id}/${course_id}`),
  /** Bulk admit-cards students list (sorted by sort_by / sort_order). */
  getExamAdmitCards: ({
    course_id,
    class_id,
    exam_id,
    sort_by = 'roll_number',
    sort_order = 'asc',
  } = {}) => {
    const instituteId = Cookies.get('institute_id')
    return apiClient.get('/exam/admit-cards', {
      params: {
        course_id,
        class_id,
        exam_id,
        sort_order: sort_order || 'asc',
        sort_by: sort_by || 'roll_number',
      },
      headers: {
        Accept: 'application/json',
        ...(instituteId ? { 'Institute-Id': Number(instituteId) } : {}),
      },
    })
  },
  /** Student admit-card exams (includes nested schedules + student profile). */
  getStudentExams: (studentId) => apiClient.get(`/student/${studentId}/exams`),
  /** Student certificates list (includes student profile). */
  getStudentCertificates: (studentId) =>
    apiClient.get(`/student/${studentId}/certificates`),
  /** Student marksheets list (includes student profile + exam results). */
  getStudentMarksheets: (studentId) =>
    apiClient.get(`/student/${studentId}/marksheets`),
  /** Student leave / transfer certificates list (includes student profile). */
  getStudentTransferCertificates: (studentId) =>
    apiClient.get(`/student/${studentId}/transfer-certificates`),

  addAttendance: (studentAttendance) =>
    apiClient.post('/attendance', studentAttendance, {
      headers: {
        ...resolveInstituteIdHeaders(),
        'Content-Type': 'application/json',
      },
    }),
  getAllAttendance: (payload) =>
    apiClient.post('/get/attendance', payload, {
      headers: {
        ...resolveInstituteIdHeaders(),
        'Content-Type': 'application/json',
      },
    }),

  getHolidayByDate: (session, payload) =>
    apiClient.post(
      `/admin/holiday/list/${encodeURIComponent(session)}/date`,
      payload,
      {
        headers: {
          'Institute-Id': Number(Cookies.get('institute_id')),
          'Content-Type': 'application/json',
        },
      },
    ),
  getHolidayList: (session, type = 'ALL') =>
    apiClient.get(`/admin/holiday/list/${encodeURIComponent(session)}/${type}`, {
      headers: {
        'Institute-Id': Number(Cookies.get('institute_id')),
      },
    }),

  markTeacherAttendance: (payload) =>
    apiClient.post('/teacher-attendance', payload, {
      headers: {
        'institute-Id': Number(Cookies.get('institute_id')),
      },
    }),
  getTeacherAttendance: (payload) =>
    apiClient.post('/get/teacher-attendance', payload, {
      headers: {
        'institute-Id': Number(Cookies.get('institute_id')),
      },
    }),
  updateTeacherAttendance: (id, payload) =>
    apiClient.put(`/teacher-attendance/${id}`, payload, {
      headers: {
        'institute-Id': Number(Cookies.get('institute_id')),
      },
    }),
  getMyTeacherAttendance: (params = {}) =>
    apiClient.get('/teacher-attendance/my', { params }),

  applyTeacherLeave: (payload) =>
    apiClient.post('/leave-requests', payload, {
      headers: {
        'Institute-Id': Number(Cookies.get('institute_id')),
        'Content-Type': 'application/json',
      },
    }),

  getMyTeacherLeaves: (params = {}) =>
    apiClient.get('/leave-requests', {
      params,
      headers: {
        'Institute-Id': Number(Cookies.get('institute_id')),
      },
    }),

  getAllTeacherLeaves: (params = {}) =>
    apiClient.get('/leave-requests', {
      params,
      headers: {
        'Institute-Id': Number(Cookies.get('institute_id')),
      },
    }),

  getLeaveRequestById: (id) => apiClient.get(`/leave-requests/${id}`),

  updateMyLeaveRequest: (id, payload) =>
    apiClient.patch(`/leave-requests/${id}`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    }),

  updateTeacherLeaveStatus: (id, payload) =>
    apiClient.put(`/leave-requests/${id}`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    }),

  deleteLeaveRequest: (id) =>
    apiClient.delete(`/leave-requests/${id}`),

  getFeeReciept: (receiptById) => apiClient.get(`/get/fees/${receiptById}`),
  addConfig: (configData) => apiClient.post('/create-setting', configData),
  // editConfig: (id, configData) =>
  //   apiClient.post(`/update-setting/${id}`, configData),

  getSession: () =>
    apiClient.get(`/get/session`),

  addBus: (busData) => apiClient.post('/transport/add', busData),
  
  getAllBuses: () =>
    apiClient.get('/transport/all', {
      headers: resolveTransportInstituteHeaders(),
    }),

    getChildBus: () =>
      apiClient.get('/parents/students/bus-details', {
        headers: resolveTransportInstituteHeaders(),
      }),

  /** Staff / TrackVehicle modal (not used on AttendantPortal — use `getMyAssignedBus` there). */
  getBusById: (id) =>
    apiClient.get(`/transport/${id}`, {
      headers: resolveTransportInstituteHeaders(),
    }),

  /** Bus attendant (and admin): buses where transport.bus_attendant_id = logged-in user. `data` may be null. */
  getMyAssignedBus: () =>
    apiClient.get('/transport/my-assigned-bus', {
      headers: resolveTransportInstituteHeaders(),
    }),

  getBusAttendants: () => {
    const instituteId = Cookies.get('institute_id')
    return apiClient.get('/get/users/bus-attendants', {
      headers: {
        Accept: 'application/json',
        'Institute-Id': Number(instituteId),
      },
    })
  },

updateBus: (id, data) => apiClient.put(`/transport/${id}`, data),

deleteBus: (id) => apiClient.delete(`/transport/${id}`),

  /** Bus attendant: start new journey or update GPS on active journey (same row). */
  transportJourneyStart: (body) =>
    apiClient.post('/transport/journey/start', body, {
      headers: resolveTransportInstituteHeaders(),
    }),

  /** Bus attendant: mark active journey completed. */
  transportJourneyComplete: (body) =>
    apiClient.post('/transport/journey/complete', body, {
      headers: resolveTransportInstituteHeaders(),
    }),

  /** Parents, admin, bus_attendant: latest stored GPS for a bus. */
  getTransportLatestLocation: (busId) =>
    apiClient.get(`/transport/${busId}/latest-location`, {
      headers: resolveTransportInstituteHeaders(),
    }),


  submitGuardianQuery: (queryData) =>
  apiClient.post('/guardian-queries', queryData, {
    headers: {
      'Institute-Id': Number(Cookies.get('institute_id')),
    },
  }),

  

  getMyQueries: () =>
  apiClient.get('/guardian-queries', {
    headers: {
      'Institute-Id': Number(Cookies.get('institute_id')),
    },
  }),


getQueryById: (id) =>
  apiClient.get(`/guardian-queries/${id}`),

updateQuery: (id, data) =>
  apiClient.put(`/guardian-queries/${id}`, data),

deleteQuery: (id) =>
  apiClient.delete(`/guardian-queries/${id}`, {
    headers: {
      'Institute-Id': Number(Cookies.get('institute_id')),
    },
}),

  getSubscriptionNeedPlan: () =>
    apiClient.get('/subscription/need-plan', {
      headers: resolveInstituteIdHeaders(),
    }),

  getCurrentSubscription: () =>
    apiClient.get('/subscription/current', {
      headers: resolveInstituteIdHeaders(),
    }),

  getSubscriptionPlans: () => apiClient.get('/subscription/plans'),

  createSubscriptionOrder: (planId) =>
    apiClient.post(
      '/subscription/create-order',
      { plan_id: planId },
      { headers: resolveInstituteIdHeaders() },
    ),

  verifySubscriptionPayment: (payload) =>
    apiClient.post('/subscription/verify-payment', payload),


}


export default ApiEndpoints




